import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../components/Converter";
import PlusIcon from "../../../../../components/Icons/PlusIcon";
import Metre from "../../../../../components/Math/Units/Metric/Metre";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";
import { selectFrontendZustand } from "../../../../../store/slices/frontendZustandSlice";
import {
  selectDickeWeicheBodenschicht,
  setDickeWeicheBodenschicht,
} from "../../../../../store/slices/innereSlice";

function DickeWeicheBodenschicht({ showImage, show }) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const dickeWeicheBodenschicht = useSelector(selectDickeWeicheBodenschicht);
  const { knickenTypeRadio } = useSelector(selectFrontendZustand);

  return (
    <RowBody
      titleValue={
        <p>
          {knickenTypeRadio == 1
            ? t("inner.buckling.lengthWeakSoilLayer")
            : t("inner.buckling.freeLength")}
        </p>
      }
      indicesValue={<span>L</span>}
      inputValue={
        <NumberFormat
          className={getClassName(dickeWeicheBodenschicht)}
          value={dickeWeicheBodenschicht}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setDickeWeicheBodenschicht(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<Metre />}
      //Nur bei KnickenOfner anzeigen
      formulaValue={
        knickenTypeRadio == 1 && (
          <span onClick={() => showImage(!show)}>
            <PlusIcon />
          </span>
        )
      }
    />
  );
}

export default DickeWeicheBodenschicht;
